module.exports = {"370113001":"文昌街道","370113002":"崮云湖街道","370113003":"平安街道","370113004":"五峰山街道","370113005":"归德街道","370113006":"张夏街道","370113007":"万德街道","370113008":"孝里街道","370113107":"马山镇","370113108":"双泉镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370113.json
// module id = 1471
// module chunks = 0